import React from 'react';
import { Plus, Download, Trash2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
interface AdminMarketingManagerProps {
  promoCodes: any[];
  banners: any[];
  setCreatePanel: (panel: any) => void;
  success: (msg: string) => void;
  handleDeletePromo: (id: number) => void;
  handleDeleteBanner: (id: number) => void;
  renderTableHeader: (title: string, count: number, onExport?: () => void, onCreate?: () => void, createLabel?: string) => React.ReactNode;
  generateCSV: (data: any[], name: string) => void;
}
export function AdminMarketingManager({
  promoCodes,
  banners,
  setCreatePanel,
  success,
  handleDeletePromo,
  handleDeleteBanner,
  renderTableHeader,
  generateCSV
}: AdminMarketingManagerProps) {
  return <div className="space-y-6" data-id="element-4280">
      <Tabs tabs={[{
      id: 'promos',
      label: 'Промокоды',
      content: <div className="space-y-4" data-id="element-4282">
                {renderTableHeader('Промокоды', promoCodes.length, () => generateCSV(promoCodes, 'promos'), () => setCreatePanel({
          type: 'promo',
          title: 'Создать промокод'
        }), 'Создать')}
                <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-4283">
                  <table className="w-full text-left" data-id="element-4284">
                    <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-4285">
                      <tr data-id="element-4286">
                        <th className="px-3 py-2" data-id="element-4287">Код</th>
                        <th className="px-3 py-2" data-id="element-4288">Скидка</th>
                        <th className="px-3 py-2" data-id="element-4289">Использовано</th>
                        <th className="px-3 py-2" data-id="element-4290">Истекает</th>
                        <th className="px-3 py-2" data-id="element-4291">Статус</th>
                        <th className="px-3 py-2" data-id="element-4292"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100" data-id="element-4293">
                      {promoCodes.map(p => <tr key={p.id} className="hover:bg-slate-50" data-id="element-4294">
                          <td className="px-3 py-2 font-mono text-sm font-bold text-slate-900" data-id="element-4295">
                            {p.code}
                          </td>
                          <td className="px-3 py-2 text-sm text-emerald-600 font-medium" data-id="element-4296">
                            {p.discount}
                          </td>
                          <td className="px-3 py-2 text-sm" data-id="element-4297">
                            {p.used} / {p.limit}
                          </td>
                          <td className="px-3 py-2 text-sm text-slate-500" data-id="element-4298">
                            {p.expires}
                          </td>
                          <td className="px-3 py-2" data-id="element-4299">
                            <Badge variant={p.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-4300">
                              {p.status === 'active' ? 'Активен' : 'Истёк'}
                            </Badge>
                          </td>
                          <td className="px-3 py-2 text-right" data-id="element-4301">
                            <Button variant="ghost" size="sm" className="text-rose-500" icon={<Trash2 className="w-3 h-3" data-id="element-4303" />} onClick={() => handleDeletePromo(p.id)} data-id="element-4302" />
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </Card>
              </div>
    }, {
      id: 'banners',
      label: 'Баннеры',
      content: <div className="space-y-4" data-id="element-4304">
                {renderTableHeader('Баннеры', banners.length, () => generateCSV(banners, 'banners'), () => setCreatePanel({
          type: 'ad',
          title: 'Добавить баннер'
        }), 'Добавить')}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4305">
                  {banners.map(b => <Card key={b.id} padding="md" data-id="element-4306">
                      <div className="flex justify-between items-start mb-3" data-id="element-4307">
                        <div data-id="element-4308">
                          <h3 className="font-bold text-slate-900" data-id="element-4309">
                            {b.title}
                          </h3>
                          <p className="text-xs text-slate-500" data-id="element-4310">
                            Размещение: {b.placement}
                          </p>
                        </div>
                        <Badge variant={b.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-4311">
                          {b.status === 'active' ? 'Активен' : 'Остановлен'}
                        </Badge>
                      </div>
                      <div className="h-24 bg-slate-100 rounded-lg border-2 border-dashed border-slate-200 flex items-center justify-center text-slate-400 text-xs mb-3" data-id="element-4312">
                        Превью баннера
                      </div>
                      <div className="flex justify-between items-center" data-id="element-4313">
                        <Button variant="outline" size="sm" onClick={() => success(b.status === 'active' ? 'Баннер остановлен' : 'Баннер запущен')} data-id="element-4314">
                          {b.status === 'active' ? 'Остановить' : 'Запустить'}
                        </Button>
                        <Button variant="ghost" size="sm" className="text-rose-500" icon={<Trash2 className="w-4 h-4" data-id="element-4316" />} onClick={() => handleDeleteBanner(b.id)} data-id="element-4315" />
                      </div>
                      <div className="flex gap-4 mt-3 text-xs text-slate-600" data-id="element-4317">
                        <span data-id="element-4318">👁 {b.views.toLocaleString()}</span>
                        <span data-id="element-4319">👆 {b.clicks.toLocaleString()}</span>
                        <span data-id="element-4320">
                          CTR: {(b.clicks / b.views * 100).toFixed(1)}%
                        </span>
                      </div>
                    </Card>)}
                </div>
              </div>
    }]} data-id="element-4281" />
    </div>;
}